import { render, staticRenderFns } from "./ClaimForm.vue?vue&type=template&id=70ff75b8&scoped=true"
import script from "./ClaimForm.vue?vue&type=script&lang=js"
export * from "./ClaimForm.vue?vue&type=script&lang=js"
import style0 from "./ClaimForm.vue?vue&type=style&index=0&id=70ff75b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff75b8",
  null
  
)

export default component.exports